import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { Tariff } from '../../tariffs/tariff.model';
import { TariffModel } from '../../tariffs/select-tariff-connection/select-tariff-connection.types';
import { MetricsService } from '../../../shared/metrics/metrics.service';
import { BpService } from '../../../core/services/bp.service';
import { IBp } from '../../../core/modules/business-process/business-process.types';
import { Pages } from '../../pages';

@Injectable({
  providedIn: 'root',
})

export class SelectKkmTariffNavigationService {
  private readonly bpStep$ = new BehaviorSubject<'selectTariff' | 'selectOptions'>('selectTariff');

  constructor(
    private metricsService: MetricsService,
    private bpService: BpService,
    private router: Router,
  ) {}

  nextBpStep(): void {
    this.bpStep$.next('selectOptions');
  }

  resetBpStep(): void {
    this.bpStep$.next('selectTariff');
  }

  getBpStep(): Observable<'selectTariff' | 'selectOptions'> {
    return this.bpStep$.asObservable();
  }

  navigateToSignPage(kkmId: number, selectedTariff: Tariff, tariffForm?: TariffModel): Observable<IBp> {
    const { id, connectionType, periodUnitsCount } = selectedTariff;
    const goalName = `Выбран тариф ${id}(${connectionType?.connection ?? ''}/${periodUnitsCount ?? ''})`;
    this.metricsService.ymGoal(goalName);
    return this.bpService.submitCurrentBp({
      consultantPhone: tariffForm?.consultantPhone,
      kkmConnectionId: tariffForm?.simNumber,
      billingPromoCode: tariffForm?.promoCode,
      tariffId: id,
    })
      .pipe(
        tap(() => {
          this.router.navigate(
            [`${Pages.Kkms}/${kkmId}/tariffs/${id}`],
            {
              queryParams: {
                ...this.bpService.getProcessIds(),
              },
              replaceUrl: true,
            },
          );
        }),
      );
  }
}
